import React, { useEffect } from 'react';
import './index.css';
import SnackbarContent from '@mui/material/SnackbarContent';
import CloseIcon from '@mui/icons-material/Close';

const NotificationCustomPage = (props) => {
  var icon = "";
  var notification_header = "";
  var notification_content = "";

  if (props.alertData) {
    icon = props.alertData.icon;
    notification_header = props.alertData.header;
    notification_content = props.alertData.content;
  }

  useEffect(() => {
    setInterval(props.closeAlert, 10000)
  })

  return (
    <SnackbarContent
      message={<div className="snackbar-alert-container">
        <div>
          <img
            src={`/static/images/icon/${icon}`}
            alt="alert_created_icon"
            style={{ maxWidth: "none" }}
          /></div>
        <div className="snackbar-alert-content">
          <div className="snackbar-alert-header">{notification_header}</div>
          <div className="snackbar-alert-sub-text">{notification_content}</div>
        </div>
        <div><CloseIcon onClick={() => props.closeAlert()} style={{ cursor: "pointer", color: "#A4B0C0" }} /></div>

      </div>
      }
      className="snackbar-alert-notification" />
  );
};

export default NotificationCustomPage;